import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#121212] group-[.toaster]:text-white group-[.toaster]:border-none group-[.toaster]:shadow-none group-[.toaster]:rounded-xl group-[.toaster]:overflow-hidden group-[.toaster]:relative",
          description: "group-[.toast]:text-zinc-500 group-[.toast]:text-sm",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
        style: {
          background:
            "linear-gradient(to right, #171717, rgba(125, 125, 125, 0.1), rgba(125, 125, 125, 0.1))",
          backdropFilter: "blur(16px)",
          opacity: 1,
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
